<template>
  <div>
    <v-card
      v-if="reason === 'chargeback'"
      class=""
      style="break-after: page; width: 210mm; min-height: 296mm; padding: 10mm"
    >
      <h4>Olá, equipe de Suporte/Chargeback,</h4>
      <p class="text-16">
        Somos a tiqueteira responsável pela intermediação da venda de ingressos
        do evento {{ party.name }}. O cliente realiza a compra em nossa
        plataforma, o pagamento é processado pelo adquirente/parceiro de
        pagamentos e, após a aprovação, emitimos e entregamos os ingressos
        digitais ao comprador. A validação de acesso no dia do evento é
        realizada por nosso sistema de check-in, registrando o uso de cada
        ingresso.
      </p>
      <v-card outlined class="rounded-lg pa-4 mb-4">
        <h5>Resumo do caso:</h5>
        <ul class="text-15">
          <li><b>Nome do cliente:</b> {{ payment?.Payer?.name }}</li>
          <li>
            <b>Nome do evento:</b> {{ party.name }} • {{ party.date | date }}
          </li>
          <li>
            <b>Ingressos comprados:</b> {{ tickets.length }} ingresso{{
              tickets.length > 1 ? "s" : ""
            }}
            digita{{ tickets.length > 1 ? "is" : "l" }}
          </li>
          <li v-if="ticketsTransferred > 0">
            <b>Transferências:</b>
            {{ ticketsTransferred }}
            {{
              ticketsTransferred > 1
                ? "ingressos foram transferidos"
                : "ingresso foi transferido"
            }}
            para terceiros pelo próprio cliente
          </li>
          <li>
            <b>Ingressos utilizados: </b>
            <span v-if="ticketsUsed === tickets.length">
              <b>Todos</b> os ingressos foram utilizados
            </span>
            <span v-else>
              {{ ticketsUsed }} dos {{ tickets.length }} ingressos foram
              utilizados
            </span>
            em {{ party.date | date }}
          </li>
          <li>
            <b>Solicitações de reembolso: </b>
            <span v-if="refoundRequests === 0">
              <b>Nenhuma</b> solicitação de reembolso recebida
            </span>
            <span v-else> Solicitação de reembolso recebida </span>
          </li>
        </ul>
        <p class="mt-3 mb-0">
          Todos os detalhes da compra e dos ingressos estão em anexo
        </p>
      </v-card>

      <v-card outlined class="rounded-lg pa-4 mb-4">
        <h5>Pontos para decisão:</h5>
        <ul class="text-15">
          <li>Produto digital entregue conforme confirmado.</li>
          <li v-if="ticketsTransferred > 0">
            Controle e posse demonstrados pelo cliente (transferência de
            {{ ticketsTransferred }} ingresso{{
              ticketsTransferred > 1 ? "s" : ""
            }}).
          </li>
          <li v-if="ticketsUsed > 0">
            Uso efetivo de {{ ticketsUsed }} ingresso{{
              ticketsUsed > 1 ? "s" : ""
            }}
            na data do evento (fruição
            {{ ticketsUsed === tickets.length ? "total" : "parcial" }} do
            serviço).
          </li>
        </ul>
      </v-card>

      <v-card outlined class="rounded-lg pa-4 mb-4">
        <h5>Solicitação:</h5>
        Solicitamos que seja analisado os fatos apresentados e, diante da
        comprovação de entrega e uso
        {{ ticketsUsed !== tickets.length ? "parcial" : "" }} do produto pelo
        consumidor, indeferir a solicitação de chargeback do cliente.
      </v-card>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    reason: {
      type: String,
      default: "chargeback",
    },
    payment: {
      type: Object,
      required: true,
    },
    tickets: {
      type: Array,
      required: true,
    },
    party: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ticketsTransferred() {
      return (
        this.tickets.filter((ticket) => ticket.TicketTransfer?.length > 0)
          .length || 0
      );
    },
    ticketsUsed() {
      return (
        this.tickets.filter((ticket) => ticket.TicketEntry?.length > 0)
          .length || 0
      );
    },
    refoundRequests() {
      return this.payment.RefoundRequest?.length || 0;
    },
  },
};
</script>
